var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAIres7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_1_",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M62,38V26l-6.16-1.54c-0.437-1.383-0.995-2.712-1.655-3.98l3.27-5.45l-8.485-8.485l-5.45,3.27    c-1.268-0.66-2.597-1.218-3.98-1.655L38,2H26l-1.54,6.16c-1.383,0.437-2.712,0.995-3.98,1.655l-5.45-3.27l-8.485,8.485l3.27,5.45    c-0.66,1.268-1.218,2.597-1.655,3.98L2,26v12l6.16,1.54c0.437,1.383,0.995,2.712,1.655,3.98l-3.27,5.45l8.485,8.485l5.45-3.27    c1.268,0.66,2.597,1.218,3.98,1.655L26,62h12l1.54-6.16c1.383-0.437,2.712-0.995,3.98-1.655l5.45,3.27l8.485-8.485l-3.27-5.45    c0.66-1.268,1.218-2.597,1.655-3.98L62,38z M32,53c-11.598,0-21-9.402-21-21c0-11.598,9.402-21,21-21s21,9.402,21,21    C53,43.598,43.598,53,32,53z",
    style: {
      fill: "#FFCB57"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.781,63H25.219l-1.595-6.382c-1.05-0.358-2.09-0.79-3.104-1.291l-5.646,3.388l-9.037-9.037    l1.414-1.414l7.934,7.934l5.26-3.157l0.497,0.259c1.239,0.645,2.524,1.179,3.819,1.587l0.533,0.169L26.781,61h10.438l1.487-5.945    l0.533-0.169c1.295-0.408,2.58-0.942,3.819-1.587l0.497-0.259l5.26,3.157l7.382-7.382l-3.157-5.26l0.259-0.497    c0.644-1.237,1.178-2.522,1.588-3.819l0.168-0.534L61,37.219V26.781l-5.945-1.487l-0.169-0.533    c-0.408-1.295-0.942-2.58-1.587-3.819l1.773-0.924c0.61,1.172,1.129,2.382,1.546,3.606L63,25.219v13.562l-6.382,1.595    c-0.358,1.051-0.791,2.091-1.291,3.104l3.388,5.646l-9.589,9.589l-5.646-3.388c-1.014,0.501-2.054,0.933-3.104,1.291L38.781,63z",
    style: {
      fill: "#3F3A34"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.928,43.982c-0.609-1.171-1.128-2.381-1.546-3.606L1,38.781V25.219l6.382-1.595    c0.358-1.05,0.79-2.09,1.291-3.104l-3.388-5.646l9.589-9.589l5.646,3.388c1.014-0.501,2.054-0.933,3.104-1.291L25.219,1h13.562    l1.595,6.382c1.05,0.358,2.09,0.79,3.104,1.291l5.646-3.388l9.037,9.037l-1.414,1.414l-7.934-7.934l-5.26,3.157l-0.497-0.259    c-1.239-0.645-2.524-1.179-3.819-1.587l-0.533-0.169L37.219,3H26.781l-1.487,5.945l-0.533,0.169    c-1.295,0.408-2.58,0.942-3.819,1.587l-0.497,0.259l-5.26-3.157l-7.382,7.382l3.157,5.26l-0.259,0.497    c-0.645,1.239-1.179,2.524-1.587,3.819l-0.169,0.533L3,26.781v10.438l5.945,1.486l0.168,0.534c0.41,1.297,0.944,2.582,1.588,3.819    L8.928,43.982z",
    style: {
      fill: "#3F3A34"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,54c-12.131,0-22-9.869-22-22s9.869-22,22-22s22,9.869,22,22S44.131,54,32,54z M32,12    c-11.028,0-20,8.972-20,20s8.972,20,20,20s20-8.972,20-20S43.028,12,32,12z",
    style: {
      fill: "#3F3A34"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3F3A34"
    },
    width: 2,
    x: 31,
    y: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3F3A34"
    },
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -5.6396 13.6152)",
    width: 2,
    x: 12.615,
    y: 12.615
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3F3A34"
    },
    width: 2,
    x: 5,
    y: 31
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3F3A34"
    },
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -31.6396 24.3848)",
    width: 2,
    x: 12.615,
    y: 49.385
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3F3A34"
    },
    width: 2,
    x: 31,
    y: 57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3F3A34"
    },
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -20.8701 50.3848)",
    width: 2,
    x: 49.385,
    y: 49.385
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3F3A34"
    },
    width: 2,
    x: 57,
    y: 31
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3F3A34"
    },
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 5.1299 39.6152)",
    width: 2,
    x: 49.385,
    y: 12.615
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38,38H26V26h12V38z M28,36h8v-8h-8V36z",
    style: {
      fill: "#3F3A34"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42,22h-5v-3h-2v3h-2v-3h-2v3h-2v-3h-2v3h-5v5h-3v2h3v2h-3v2h3v2h-3v2h3v5h5v3h2v-3h2v3h2v-3h2v3h2    v-3h5v-5h3v-2h-3v-2h3v-2h-3v-2h3v-2h-3V22z M40,40H24V24h16V40z",
    style: {
      fill: "#E56565"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 27,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 31,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 35,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 15,
    y: 35
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 15,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 15,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 35,
    y: 47
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 31,
    y: 47
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 27,
    y: 47
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 47,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 47,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#E56565"
    },
    width: 2,
    x: 47,
    y: 35
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAIres7);
export default __webpack_public_path__ + "static/media/AIres7.cc628869568b20d61ed92e353ac5312e.svg";
export { ForwardRef as ReactComponent };